import { useEffect, useState } from "react";
import { BASE_API_URL } from "../../Components/config";

/**
 * How many students the space has — the teacher's to know (the board's
 * turnout bars, the people panel). Null until known, or for a student.
 */
export function useStudentCount(courseGuid, enabled) {
  const [count, setCount] = useState(null);
  useEffect(() => {
    if (!courseGuid || !enabled) return undefined;
    let live = true;
    fetch(`${BASE_API_URL}/api/v1/user-course-links/students-by-course-guid/${courseGuid}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
    })
      .then((r) => (r.ok ? r.json() : []))
      .then((rows) => live && setCount(Array.isArray(rows) ? rows.length : 0))
      .catch(() => live && setCount(null));
    return () => {
      live = false;
    };
  }, [courseGuid, enabled]);
  return count;
}
